import { FULL_CARD_SIZES } from '../../features/cards';
import ContentCardSkeleton from './ContentCardSkeleton';
import ReducedCardSkeleton from './ReducedCardSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const LearningContentCardsSkeleton = ({
  skeletonCardSize,
  use,
  maxSkeletonListLength = 4
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: [...Array(maxSkeletonListLength)].map((_, i) => FULL_CARD_SIZES.includes(skeletonCardSize) ? /*#__PURE__*/_jsx(ContentCardSkeleton, {
      cardSize: skeletonCardSize,
      marginBlockEnd: "0",
      use: use
    }, i) : /*#__PURE__*/_jsx(ReducedCardSkeleton, {
      size: skeletonCardSize,
      use: use
    }, i))
  });
};